import { useState } from "react";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import UpdateButtonTrigger from "../../../../../../../shared/components/button/UpdateButtonTrigger";
import EditPagesPermissionsForm from "./EditPagesPermissionsForm";

const EditPagesPermissionsDialog = ({ onSubmitHandler, pageRoute }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger />}
      title="Editar accesos"
      description="Editar la configuración de los accesos a las páginas del Control Centre"
      content={
        <EditPagesPermissionsForm
          onSubmitHandler={onSubmit}
          pageRoute={pageRoute}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default EditPagesPermissionsDialog;
